module.exports = __webpack_public_path__ + "img/arrow-right.3c5033ef.svg";